import * as i0 from '@angular/core';
import { Directive, Input, HostListener, EventEmitter, Component, Output, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@rogers/cdk/icon';
import { IconComponent } from '@rogers/cdk/icon';
import * as i4 from '@rogers/cdk/form';
import { FormModule } from '@rogers/cdk/form';
import * as i5 from '@rogers/self-serve-analytics';
import { AnalyticsModule } from '@rogers/self-serve-analytics';
import * as i6 from '@rogers/self-serve-utils/auto-focus';
import { AutoFocusModule } from '@rogers/self-serve-utils/auto-focus';
import { get } from 'lodash';
import { TranslateModule } from '@ngx-translate/core';
function AmountFieldComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("errorMessage", ctx_r0.errorMessage);
  }
}
let AmountFormatDirective = /*#__PURE__*/(() => {
  class AmountFormatDirective {
    constructor(_el, currencyPipe, control) {
      this._el = _el;
      this.currencyPipe = currencyPipe;
      this.control = control;
      this.amountSeperator = '.'; // default
      this.amountCurrencyCode = 'CAD'; // default
      this.amountDisplay = 'symbol-narrow'; // default
      this.amountDigitsInfo = '1.2-2'; // default
      this.amountLocale = 'en'; // default
      this.amountPattern = /^\d+(\.\d{0,2})?$/g; // default
      this.AMOUNT_SEPARATOR = '.';
    }
    ngOnChanges() {
      this._el.nativeElement.value = this.displayValue;
    }
    onInputChange(event) {
      if (!this.controlValue.match(this.amountPattern)) {
        this.setControlValue(this.controlValue.slice(0, -1));
        event.stopPropagation();
      } else {
        this.setControlValue(this.controlValue);
      }
      this._el.nativeElement.value = this.displayValueEdit;
    }
    onFocusout() {
      this.setControlValue(Number(this.controlValue).toString());
      this._el.nativeElement.value = this.displayValue;
    }
    onFocusin() {
      this._el.nativeElement.value = this.displayValueEdit;
    }
    get displayValue() {
      return this.currencyPipe.transform(this.controlValue, this.amountCurrencyCode, this.amountDisplay, this.amountDigitsInfo, this.amountLocale);
    }
    get displayValueEdit() {
      return get(this.control, 'control.value') ? this.control.control.value.toString().replace(this.AMOUNT_SEPARATOR, this.amountSeperator) : '';
    }
    get controlValue() {
      return get(this.control, 'control.value') ? this.control.control.value.toString() : '';
    }
    setControlValue(value) {
      if (this.control && this.control.control) {
        this.control.control.setValue(value.replace(this.amountSeperator, this.AMOUNT_SEPARATOR));
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AmountFormatDirective_Factory(t) {
        return new (t || AmountFormatDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CurrencyPipe), i0.ɵɵdirectiveInject(i2.NgControl));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AmountFormatDirective,
        selectors: [["", "ssAmountFormat", ""]],
        hostBindings: function AmountFormatDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function AmountFormatDirective_input_HostBindingHandler($event) {
              return ctx.onInputChange($event);
            })("focusout", function AmountFormatDirective_focusout_HostBindingHandler() {
              return ctx.onFocusout();
            })("focusin", function AmountFormatDirective_focusin_HostBindingHandler() {
              return ctx.onFocusin();
            });
          }
        },
        inputs: {
          amountSeperator: "amountSeperator",
          amountCurrencyCode: "amountCurrencyCode",
          amountDisplay: "amountDisplay",
          amountDigitsInfo: "amountDigitsInfo",
          amountLocale: "amountLocale",
          amountPattern: "amountPattern"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return AmountFormatDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable */
const AMOUNT_VALIDATION_PATTERN_EN = /^\d+(\.\d{0,2})?$/g;
const AMOUNT_VALIDATION_PATTERN_FR = /^\d+(,\d{0,2})?$/g;
const DECIMAL_SEPERATOR_EN = '.';
const DECIMAL_SEPERATOR_FR = ',';
let AmountFieldComponent = /*#__PURE__*/(() => {
  class AmountFieldComponent {
    constructor() {
      this.altText = '';
      this.autoFocus = true;
      this.formClass = '';
      this.hintMessage = '';
      this.readonly = false;
      this.wrapperClass = '';
      this.change = new EventEmitter();
      this.focus = new EventEmitter();
    }
    get amountPattern() {
      return this.language === 'en' ? AMOUNT_VALIDATION_PATTERN_EN : AMOUNT_VALIDATION_PATTERN_FR;
    }
    get amountAltText() {
      return this.language === 'en' ? `${this.altText}$${this.amountControl.value.toString()}` : `${this.altText}${this.amountControl.value.toString().replace(DECIMAL_SEPERATOR_EN, DECIMAL_SEPERATOR_FR)}$`;
    }
    get decimalSeparator() {
      return this.language === 'en' ? DECIMAL_SEPERATOR_EN : DECIMAL_SEPERATOR_FR;
    }
    onChange() {
      this.change.emit();
    }
    onFocus() {
      this.focus.emit();
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AmountFieldComponent_Factory(t) {
        return new (t || AmountFieldComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AmountFieldComponent,
        selectors: [["ss-amount-field"]],
        inputs: {
          altText: "altText",
          amountControl: "amountControl",
          analyticsConfig: "analyticsConfig",
          autoFocus: "autoFocus",
          errorMessage: "errorMessage",
          formClass: "formClass",
          hintMessage: "hintMessage",
          inputLabel: "inputLabel",
          language: "language",
          readonly: "readonly",
          showAmountError: "showAmountError",
          wrapperClass: "wrapperClass"
        },
        outputs: {
          change: "change",
          focus: "focus"
        },
        decls: 8,
        vars: 13,
        consts: [[1, "mt-16", 3, "ngClass"], [3, "ngClass"], ["dsInput", "", "ssAmountFormat", "", "type", "text", 3, "focus", "input", "amountSeperator", "amountLocale", "amountPattern", "formControl", "readonly", "ssAutoFocus"], ["dsSuffix", "", 3, "name"], ["ssTrackError", "", "error", "analyticsConfig", "role", "alert", "aria-live", "polite", 3, "errorMessage"], [3, "hintMessage"]],
        template: function AmountFieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ds-form-field", 1)(2, "ds-input-label");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "input", 2);
            i0.ɵɵlistener("focus", function AmountFieldComponent_Template_input_focus_4_listener() {
              return ctx.onFocus();
            })("input", function AmountFieldComponent_Template_input_input_4_listener() {
              return ctx.onChange();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "ds-icon", 3);
            i0.ɵɵtemplate(6, AmountFieldComponent_Conditional_6_Template, 1, 1, "ds-error", 4);
            i0.ɵɵelement(7, "ds-hint", 5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.wrapperClass);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.formClass);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.inputLabel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("amountSeperator", ctx.decimalSeparator)("amountLocale", ctx.language)("amountPattern", ctx.amountPattern)("formControl", ctx.amountControl)("readonly", ctx.readonly)("ssAutoFocus", ctx.autoFocus);
            i0.ɵɵattribute("aria-label", ctx.amountAltText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", "money");
            i0.ɵɵadvance();
            i0.ɵɵconditional(6, ctx.showAmountError ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hintMessage", ctx.hintMessage);
          }
        },
        dependencies: [i1.NgClass, i2.DefaultValueAccessor, i2.NgControlStatus, i3.IconComponent, i2.FormControlDirective, i4.FormFieldComponent, i4.InputFormDirective, i4.InputLabelComponent, i4.ErrorComponent, i4.HintComponent, i4.SuffixDirective, i5.TrackErrorDirective, i6.AutoFocusDirective, AmountFormatDirective],
        encapsulation: 2
      });
    }
  }
  return AmountFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AmountFieldModule = /*#__PURE__*/(() => {
  class AmountFieldModule {
    /** @nocollapse */static {
      this.ɵfac = function AmountFieldModule_Factory(t) {
        return new (t || AmountFieldModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AmountFieldModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, IconComponent, ReactiveFormsModule, TranslateModule, FormModule, AnalyticsModule, AutoFocusModule]
      });
    }
  }
  return AmountFieldModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AmountFieldComponent, AmountFieldModule };
